import { useDispatch } from 'react-redux';
import { notifyError } from '~/components/common/ToastMessages';
import appleSVG from '~/images/apple.svg';
import { appleLoginAction } from '~/store/actions';

const APPLE_AUTH_CONFIG = {
	clientId: 'com.undergroundshop.apple-login',
	scope: 'email name',
	redirectURI: 'https://www.undergroundshop.gr/applelogin',
	state: 'state',
	usePopup: true,
	response_mode: 'form_post'
};

const AppleLoginButton = () => {
	const dispatch = useDispatch();

	const handleSignIn = async () => {
		// appleid.auth.js is loaded async from index.html: initialising on mount crashed the whole page when it was not there yet.
		if (!window.AppleID) return;

		try {
			window.AppleID.auth.init(APPLE_AUTH_CONFIG);
			const response = await window.AppleID.auth.signIn();
			dispatch(appleLoginAction(response));
		} catch (error) {
			console.log(error);
			if (error?.error === 'popup_closed_by_user') return;
			notifyError('Υπάρχει ήδη λογαριασμός που χρησιμοποιεί αυτό το email');
		}
	};

	return (
		<button type="button" onClick={handleSignIn} className="flex-col">
			<img src={appleSVG} alt="" />
			Apple
		</button>
	);
};

export default AppleLoginButton;
